module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBold.db41bca4.woff";